import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardBody } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { CheckIcon, HeartIcon, GlobeIcon, UsersIcon } from 'lucide-react';
export function About() {
  const teamMembers = [{
    name: 'Alexandra Rivera',
    role: 'Director of Events',
    bio: '15+ years experience in luxury hospitality and event management across the Caribbean.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2076&q=80'
  }, {
    name: 'Carlos Mendez',
    role: 'Head of Sales',
    bio: 'Former resort executive with deep connections throughout Cancun and Riviera Maya.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    name: 'Maria Sanchez',
    role: 'Event Manager',
    bio: 'Bilingual event specialist focused on creating seamless guest experiences.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1961&q=80'
  }, {
    name: 'David Thompson',
    role: 'Onsite Concierge',
    bio: 'Dedicated to ensuring every detail is perfect during your event.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80'
  }];
  const esgInitiatives = [{
    title: 'Carbon Offset Program',
    description: 'Every DestaMeet event is 100% carbon-offset through our partnership with verified carbon reduction projects.',
    icon: <GlobeIcon className="h-8 w-8 text-[#0099A1]" data-id="element-366" />
  }, {
    title: 'Reef Restoration',
    description: 'A portion of every booking supports local coral reef restoration projects in the Mexican Caribbean.',
    icon: <HeartIcon className="h-8 w-8 text-[#0099A1]" data-id="element-367" />
  }, {
    title: 'Local Supplier Network',
    description: 'We prioritize local vendors and suppliers to support the communities where we operate.',
    icon: <UsersIcon className="h-8 w-8 text-[#0099A1]" data-id="element-368" />
  }];
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-369">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-370">
        <div className="container mx-auto px-4 md:px-6" data-id="element-371">
          <div className="max-w-3xl" data-id="element-372">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-373">
              About & ESG
            </h1>
            <p className="text-xl text-white/90" data-id="element-374">
              Learn about our company, our values, and our commitment to
              sustainable practices.
            </p>
          </div>
        </div>
      </section>

      {/* About DestaMeet */}
      <section className="py-16 bg-white" data-id="element-375">
        <div className="container mx-auto px-4 md:px-6" data-id="element-376">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-377">
            <div data-id="element-378">
              <h2 className="text-3xl font-bold text-[#374047] mb-6" data-id="element-379">
                About DestaMeet
              </h2>
              <p className="text-lg text-[#374047]/80 mb-6" data-id="element-380">
                DestaMeet is the MICE division of Desta Group, specializing in
                corporate meetings, incentives, and brand launches in Cancun &
                Riviera Maya.
              </p>
              <p className="text-lg text-[#374047]/80 mb-6" data-id="element-381">
                We transform ordinary corporate events into extraordinary
                experiences that deliver measurable business results. Our
                end-to-end approach ensures every detail is handled with
                precision and care.
              </p>
              <div className="space-y-4" data-id="element-382">
                <div className="flex items-start" data-id="element-383">
                  <CheckIcon className="h-6 w-6 text-[#0099A1] flex-shrink-0 mt-0.5" data-id="element-384" />
                  <div className="ml-3" data-id="element-385">
                    <h3 className="font-semibold text-[#374047]" data-id="element-386">
                      Radical Personalization
                    </h3>
                    <p className="text-[#374047]/70" data-id="element-387">
                      Every event is custom-designed to meet your specific
                      business objectives.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-388">
                  <CheckIcon className="h-6 w-6 text-[#0099A1] flex-shrink-0 mt-0.5" data-id="element-389" />
                  <div className="ml-3" data-id="element-390">
                    <h3 className="font-semibold text-[#374047]" data-id="element-391">
                      Seamless End-to-End Logistics
                    </h3>
                    <p className="text-[#374047]/70" data-id="element-392">
                      From flights to farewell, we handle every detail so you
                      can focus on your team.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-393">
                  <CheckIcon className="h-6 w-6 text-[#0099A1] flex-shrink-0 mt-0.5" data-id="element-394" />
                  <div className="ml-3" data-id="element-395">
                    <h3 className="font-semibold text-[#374047]" data-id="element-396">
                      Measurable Impact
                    </h3>
                    <p className="text-[#374047]/70" data-id="element-397">
                      We help you track and measure the ROI of your event
                      investment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative" data-id="element-398">
              <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="DestaMeet team planning an event" className="rounded-xl shadow-lg" data-id="element-399" />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-lg" data-id="element-400">
                <img src="https://images.unsplash.com/photo-1540541338287-41700207dee6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Beach resort venue" className="w-32 h-24 object-cover rounded-lg" data-id="element-401" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ESG Initiatives */}
      <section className="py-16 bg-[#F4E8D0]/50" data-id="element-402">
        <div className="container mx-auto px-4 md:px-6" data-id="element-403">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-404">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-405">
              Our ESG Commitments
            </h2>
            <p className="text-lg text-[#374047]/80" data-id="element-406">
              We're committed to creating exceptional experiences that also
              respect and support the environment and local communities.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-407">
            {esgInitiatives.map((initiative, index) => <Card key={index} className="h-full" data-id="element-408">
                <CardHeader className="flex flex-col items-center text-center" data-id="element-409">
                  {initiative.icon}
                  <h3 className="text-xl font-semibold text-[#374047] mt-4" data-id="element-410">
                    {initiative.title}
                  </h3>
                </CardHeader>
                <CardBody className="text-center" data-id="element-411">
                  <p className="text-[#374047]/80" data-id="element-412">{initiative.description}</p>
                </CardBody>
              </Card>)}
          </div>
          <div className="mt-12 text-center" data-id="element-413">
            <Button variant="outline" to="/contact" data-id="element-414">
              Learn More About Our ESG Initiatives
            </Button>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-16 bg-white" data-id="element-415">
        <div className="container mx-auto px-4 md:px-6" data-id="element-416">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-417">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-418">
              Meet Our Team
            </h2>
            <p className="text-lg text-[#374047]/80" data-id="element-419">
              Our experienced professionals are dedicated to creating
              exceptional experiences for your organization.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-420">
            {teamMembers.map((member, index) => <div key={index} className="text-center" data-id="element-421">
                <div className="mb-4 relative" data-id="element-422">
                  <div className="aspect-square overflow-hidden rounded-full" data-id="element-423">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-424" />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-[#374047]" data-id="element-425">
                  {member.name}
                </h3>
                <p className="text-[#0099A1] font-medium mb-2" data-id="element-426">{member.role}</p>
                <p className="text-sm text-[#374047]/70" data-id="element-427">{member.bio}</p>
              </div>)}
          </div>
        </div>
      </section>

      <CtaSection data-id="element-428" />
    </div>;
}